<template>
  <v-container  grid-list-sm>
    <v-card
      class="elevation-6"
      color="white"
      >
      <v-card-title>
        <v-layout row wrap>
          <v-flex shrink>
            <v-icon  color="primary">
              folder_shared
            </v-icon>
          </v-flex>
          <v-flex grow >
            <span class="title font-weight-light primary--text "><h3>Reporte Post Encuesta</h3></span>
          </v-flex>

        </v-layout>

      </v-card-title>

      <v-card-text v-if="reporteview==false" class="headline font-weight">
        Gracias por tu reporte, aquí está la información para tí y los tuyos:
      </v-card-text>
      <v-card-text v-else-if="cargando==false" class="headline font-weight">
        <v-layout row wrap>
          <v-flex shrink>
            <h4>Nombre:</h4 >
          </v-flex>
          <v-flex grow>
            {{nombre}}
          </v-flex>
        </v-layout>

      </v-card-text>
        <v-layout align-center  fill-height pa-3 v-if="reporteview">

          <v-flex  align-content-center v-if="cargando" row >
            <v-progress-circular
              :size="50"
              color="blue"
              indeterminate
              centered
            ></v-progress-circular>
          </v-flex>

          <v-flex  v-else>
              <v-layout align-center justify-center row wrap>
                <!-- TEMPERATURA -->
                <v-flex v-if="temperatura" xs12 md4 lg4>
                  <v-card color="white">
                    <h3  class="text-md-center">Temperatura</h3>

                      <v-card-text
                          v-if="loadingAdv"
                          class="text-xs-center"
                          >
                          <v-progress-circular
                          :size="progressSize"
                          :width="progressWidth"
                          color="info"
                          indeterminate
                          ></v-progress-circular>
                      </v-card-text>

                      <v-card-text v-else-if="seriesAdv===null">
                        <h4 class="text-md-center" color="error">No se encontraron datos relacionados a la cédula</h4>
                      </v-card-text>

                      <v-card-text v-else>
                          <chart-line
                          :chartOptions="chartOptionsAdv"
                          :chartSeries="chartSeriesAdv"
                          :key="chartAdvKey"
                          />
                      </v-card-text>
                  </v-card>
                </v-flex>
                <!-- RITMO CARDIACO -->
                <v-flex v-if="rcardiaco" xs12 md4 lg4 >
                  <v-card>
                    <h3 class="text-md-center">Ritmo Cardiaco</h3>

                    <v-card-text
                        v-if="loadingAdv"
                        class="text-xs-center"
                        >
                        <v-progress-circular
                        :size="progressSize"
                        :width="progressWidth"
                        color="info"
                        indeterminate
                        ></v-progress-circular>
                    </v-card-text>
                    <v-card-text v-else-if="seriesAdv2===null">
                      <h4 class="text-md-center" color="error">No se encontraron datos relacionados a la cedula</h4>
                    </v-card-text>

                    <v-card-text v-else>
                        <chart-line
                        :chartOptions="chartOptionsAdv2"
                        :chartSeries="chartSeriesAdv2"
                        :key="chartAdvKey2"
                        />
                    </v-card-text>
                  </v-card>

                </v-flex>

                <!-- OXIMETRIA -->
                <v-flex v-if="oximetria" xs12 md4 lg4 >
                  <v-card>
                    <h3 class="text-md-center">Oximetria</h3>

                    <v-card-text
                      v-if="loadingAdv"
                      class="text-xs-center"
                      >
                      <v-progress-circular
                        :size="progressSize"
                        :width="progressWidth"
                        color="info"
                        indeterminate
                      ></v-progress-circular>
                    </v-card-text>

                    <v-card-text v-else-if="seriesAdv3===null">
                      <h4 class="text-md-center" color="error">No se encontraron datos relacionados a la cedula</h4>
                    </v-card-text>

                    <v-card-text v-else>

                      <chart-line
                      :chartOptions="chartOptionsAdv3"
                      :chartSeries="chartSeriesAdv3"
                      :key="chartAdvKey3"
                      />
                    </v-card-text>
                  </v-card>

                </v-flex>

                <v-flex xs12 md12 lg12 >

                  <v-layout row wrap>
                    <v-flex lg3 md3>

                      <v-card >
                        <v-card-text>
                          {{texto_probabilidad}}
                        </v-card-text>
                        <h2 v-bind:class="color_probabilidad">{{valor_probabilidad}}</h2>
                      </v-card>
                    </v-flex>
                    <v-flex lg3 md3>

                      <v-card>
                        <v-card-text>
                          {{texto_entorno}}
                        </v-card-text>
                        <h2 v-bind:class="color_entorno" >{{valor_entorno}}</h2>
                      </v-card>
                    </v-flex>
                    <v-flex lg6 md6>

                      <v-card  :min-height=20>
                        <v-card-title primary-title class="text-xs-justify font-weight-medium text-uppercase">
                          {{mensaje_diario[numero].titulo}}
                        </v-card-title>
                        <!-- <h3 class="text-md-center text-xs-center"></h3> -->

                        <v-card-text>
                          <v-layout align-center justify-center row fill-height>
                            <v-flex xs10>
                              <p class="text-xs-justify ">
                                {{mensaje_diario[numero].text}}
                              </p>
                            </v-flex>
                            <v-flex xs2>
                              <v-icon size="50" color="primary">
                                {{mensaje_diario[numero].icon}}
                              </v-icon>

                            </v-flex>
                          </v-layout>

                        </v-card-text>

                      </v-card>
                    </v-flex>
                  </v-layout>

                </v-flex>
              </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>

          <v-flex v-if="btnReporte" xs1>
            <v-btn class="elevation-6" round color="green" dark v-on:click="getReporte">
              ver ficha personal
              <v-icon medium right>
                person_add
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

    </v-card>
  </v-container>
</template>
<script>
import chartLine from '@/components/Charts/LineBase'

export default {
  name: 'Ficha Personal',
  components: {
    'chart-line': chartLine
  },

  data () {
    return {

      backConf: {
        // path: '/briefcase/ls_one_covid/',
        // path: '/projects/covid/reporte_post_encuesta/?token=3176481631',
        path: '/projects/covid/reporte_post_encuesta/',
        pathToken: '/projects/covid/token_postencuesta/',
        page: 1
      },
      tokenFinal: null,
      key: 1,

      reporteview: false,

      cargando: false,

      texto_probabilidad: 'Con base en lo que he reportado, la probabilidad de tener COVID hoy es:',
      texto_entorno: 'Con base en lo que he reportado, estoy en un ENTORNO de riesgo de adquirir el COVID:',
      color_probabilidad: 'blue--text text--darken-3 text-md-center text-xs-center',
      // valor_probabilidad: 'BAJA',
      valor_entorno: 'MODERADO',
      color_entorno: 'orange--text text--darken-3 text-md-center text-xs-center ',
      mensaje_diario: [
        { titulo: 'Practicar el distanciamiento social',
          text: 'Si está rodeado de otras personas, mantenga una distancia de 6 pies cuando sea posible. Evite los abrazos, dar la mano, las reuniones grandes y los ambientes cerrados. ',
          icon: '6_ft_apart'
        },
        { icon: 'face',
          titulo: 'Cubra su rostro con un paño de tela en público',
          text: ' Cúbrase la boca y la nariz con un paño de tela para el rostro cuando esté alrededor de otras personas y en público, como en el supermercado.'
        },
        { icon: 'clean_hands',
          titulo: 'Evitar tocarse los ojos, la nariz y la boca',
          text: 'Las manos tocan muchas superficies y pueden levantar los virus. Procure lavar sus manos cada 3 horas.'
        },
        { icon: 'sick',
          titulo: 'Cubrirse al toser y estornudar',
          text: 'Cúbrase la boca y la nariz con un pañuelo cuando tosa o estornude o use la parte interna del codo. Tire los pañuelos usados a la basura.'
        },
        { icon: 'coronavirus',
          titulo: 'Limpiar y desinfectar las superficies de “alto contacto”',
          text: 'Limpie Y desinfecte con frecuencia las superficies de contacto diario, es decir, mesas, perillas de las puertas, llaves de luz, encimeras, manijas, escritorios, teléfonos, teclados, inodoros, grifos y fregaderos.'
        }
      ],
      nombre: null,

      // variables para saber por medio de peticion
      // si aplica o no reportes de cada tipo.
      oximetria: false,
      temperatura: false,
      rcardiaco: false,

      // numero aleatorio para poner mensaje
      numero: null,
      mensaje: null,

      valor_probabilidad: null,

      btnReporte: true,

      loadingAdv: false,
      seriesAdv: null,
      chartAdvKey: null,
      chartOptionsAdv: {
        chart: {
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        colors: ['#FF1654', '#247BA0'],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: true,
          position: 'bottom'
        },
        stroke: {
          curve: 'smooth'
        },

        responsive: [
          {
            breakpoint: 721,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ],

        markers: {
          size: 5,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            rotate: -15,
            rotateAlways: true
          },
          title: {
            text: 'Fecha'
          }
        },
        yaxis: [

          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              colors: ['#FF1654', '#247BA0']
            },
            labels: {
              style: {
                color: '#00E396'
              }
            },
            opposite: true,
            title: {
              text: 'Avance Acumulado',
              style: {
                color: '#00E396'
              }
            },
            tooltip: {
              enabled: true
            }
          }

        ]
        // tooltip: {
        //   fixed: {
        //     enabled: true,
        //     position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        //     offsetY: 30,
        //     offsetX: 60
        //   }
        // }
      },
      chartSeriesAdv: null,

      loadingAdv2: false,
      seriesAdv2: null,
      chartAdvKey2: null,
      chartOptionsAdv2: {
        chart: {
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        colors: ['#FF1654', '#247BA0'],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: true,
          position: 'bottom'
        },
        stroke: {
          curve: 'smooth'
        },

        responsive: [
          {
            breakpoint: 721,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ],

        markers: {
          size: 5,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            rotate: -15,
            rotateAlways: true
          },
          title: {
            text: 'Fecha'
          }
        },
        yaxis: [

          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              colors: ['#FF1654', '#247BA0']
            },
            labels: {
              style: {
                color: '#00E396'
              }
            },
            opposite: true,
            title: {
              text: 'Avance Acumulado',
              style: {
                color: '#00E396'
              }
            },
            tooltip: {
              enabled: true
            }
          }

        ]
        // tooltip: {
        //   fixed: {
        //     enabled: true,
        //     position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        //     offsetY: 30,
        //     offsetX: 60
        //   }
        // }
      },
      chartSeriesAdv2: null,

      loadingAdv3: false,
      seriesAdv3: null,
      chartAdvKey3: null,
      chartOptionsAdv3: {
        chart: {
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        colors: ['#FF1654', '#247BA0'],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: true,
          position: 'bottom'
        },
        stroke: {
          curve: 'smooth'
        },

        responsive: [
          {
            breakpoint: 721,
            options: {
              legend: {
                position: 'bottom'
              }
            }
          }
        ],

        markers: {
          size: 5,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            rotate: -15,
            rotateAlways: true
          },
          title: {
            text: 'Fecha'
          }
        },
        yaxis: [

          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              colors: ['#FF1654', '#247BA0']
            },
            labels: {
              style: {
                color: '#00E396'
              }
            },
            opposite: true,
            title: {
              text: 'Oximetria',
              style: {
                color: '#00E396'
              }
            },
            tooltip: {
              enabled: true
            }
          }

        ]
        // tooltip: {
        //   fixed: {
        //     enabled: true,
        //     position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        //     offsetY: 30,
        //     offsetX: 60
        //   }
        // }
      },
      chartSeriesAdv3: null,

      tokentoken: null

    }
  },
  created () {
    // this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    // this.operativo = this.$store.state.actualOperation.id
    this.token = this.$route.params.token
    // this.operativo = 41
    // this.getToken()
    this.numero = Math.round(Math.random() * 4)
  },

  methods: {

    getReporte () {
      this.btnReporte = false
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          rt: this.token
        }

      }

      this.reporteview = true
      this.cargando = true

      let t = this
      this.$store.dispatch('request_back', request)

        .then(function (resp) {
          t.nombre = resp.data['nombre']
          t.percent = parseFloat(resp.data['percent'])

          if (t.percent <= 0.2) {
            t.valor_probabilidad = 'MUY BAJO'
          } else if (t.percent > 0.2 && t.percent <= 0.4) {
            t.valor_probabilidad = 'BAJO'
          } else if (t.percent > 0.4 && t.percent <= 0.6) {
            t.valor_probabilidad = 'MODERADO'
          } else if (t.percent > 0.6 && t.percent <= 0.8) {
            t.valor_probabilidad = 'ALTO'
          } else {
            t.valor_probabilidad = 'MUY ALTO'
          }

          if (resp.data['temperatura']) {
            t.temperatura = true
          }
          if (resp.data['rcardiaco']) {
            t.rcardiaco = true
          }
          if (resp.data['oximetria']) {
            t.oximetria = true
          }

          try {
            if (resp.data['temperatura'][0].length === 0) {
              // console.log('no hay nada Oximetria')
              t.mensaje = 'No hay registros relacionados a la cédula '
              // console.log("seriesAdv3:");
              // console.log(t.seriesAdv3);
            } else {
              t.seriesAdv = resp.data.temperatura
              // console.log('SERIES:')
              // console.log(t.seriesAdv3)
              t.mensaje = ''
              t.ChangeAdvance()
              t.loadingAdv = false
              t.chartAdvKey += 1
            }
          } catch (error) {
            console.log(error)
          }

          try {
            if (resp.data['rcardiaco'][0].length === 0) {
              // console.log('no hay nada Oximetria')
              t.mensaje = 'No hay registros relacionados a la cédula '
              // console.log("seriesAdv3:");
              // console.log(t.seriesAdv3);
            } else {
              t.seriesAdv2 = resp.data.rcardiaco
              // console.log('SERIES:')
              // console.log(t.seriesAdv3)
              t.mensaje = ''
              t.ChangeAdvance2()
              t.loadingAdv2 = false
              t.chartAdvKey2 += 1
            }
          } catch (error) {
            console.log(error)
          }

          try {
            if (resp.data['oximetria'][0].length === 0) {
              // console.log('no hay nada Oximetria')
              t.mensaje = 'No hay registros relacionados a la cédula '
              // console.log("seriesAdv3:");
              // console.log(t.seriesAdv3);
            } else {
              t.seriesAdv3 = resp.data.oximetria
              // console.log('SERIES:')
              // console.log(t.seriesAdv3)
              t.mensaje = ''
              t.ChangeAdvance3()
              t.loadingAdv3 = false
              t.chartAdvKey3 += 1
            }
          } catch (error) {
            console.log(error)
          }

          t.cargando = false
        })
        .catch(err => console.error(err))
    },

    /**
    * Funcion para configurar timeline de Temperatura
    */
    ChangeAdvance () {
      this.chartSeriesAdv = this.seriesAdv

      if (this.chartSeriesAdv[0]) {
        console.log('chart series 0')
        this.chartSeriesAdv[0].name = 'am'
      }
      if (this.chartSeriesAdv[1]) {
        console.log('chart series 1')
        this.chartSeriesAdv[1].name = 'pm'
      }

      // console.log('chartSeriesAdv')
      // console.log(this.chartSeriesAdv)

      this.chartOptionsAdv.colors = ['#FF1654', '#247BA0']
      this.chartOptionsAdv.yaxis = [
        {
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
            colors: ['#FF1654', '#247BA0']
          },
          labels: {
            style: {
              color: '#00E396'
            }
          },
          title: {
            text: 'Temperatura',
            style: {
              color: '#00E396'
            }
          },
          tooltip: {
            enabled: true
          }
        }
      ]

      this.advance = !this.advance
      this.chartAdvKey += 1
    },

    /**
     * Funcion para configurar timeline de Ritmo Cardiaco
     */
    ChangeAdvance2 () {
      // console.log('ChangeAdvance2')
      this.chartSeriesAdv2 = this.seriesAdv2

      this.chartSeriesAdv2[0].name = 'am'

      this.chartSeriesAdv2[1].name = 'pm'
      // console.log(this.chartSeriesAdv2)
      this.chartOptionsAdv2.colors = ['#FF1654', '#247BA0']
      this.chartOptionsAdv2.yaxis = [
        {
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
            colors: ['#FF1654', '#247BA0']
          },
          labels: {
            style: {
              color: '#00E396'
            }
          },
          title: {
            text: 'Ritmo Cardiaco',
            style: {
              color: '#00E396'
            }
          },
          tooltip: {
            enabled: true
          }
        }
      ]

      this.advance = !this.advance
      this.chartAdvKey2 += 1
    },

    /**
     * Funcion para configurar timeline de Oximetria
     */
    ChangeAdvance3 () {
      // console.log('ChangeAdvance3')
      this.chartSeriesAdv3 = this.seriesAdv3
      this.chartSeriesAdv3[0].name = 'am'
      this.chartSeriesAdv3[1].name = 'pm'

      this.chartOptionsAdv3.colors = ['#FF1654', '#247BA0']
      this.chartOptionsAdv3.yaxis = [
        {
          axisTicks: {
            show: true
          },
          axisBorder: {
            show: true,
            colors: ['#FF1654', '#247BA0']
          },
          labels: {
            style: {
              color: '#00E396'
            }
          },
          title: {
            text: 'Oximetria',
            style: {
              color: '#00E396'
            }
          },
          tooltip: {
            enabled: true
          }
        }
      ]

      this.advance = this.advance
      this.chartAdvKey3 += 1
    },

    // Esta funcion es para pruebas***
    getToken () {
      console.log(this.operativo)
      console.log(this.token)

      this.btnReporte = false
      let request = {
        method: 'post',
        url: this.backConf.pathToken,
        data: {
          op: this.operativo,
          token: this.token

        }

      }

      this.reporteview = true
      this.cargando = true

      let t = this
      this.$store.dispatch('request_back', request)

        .then(function (resp) {
          t.token = resp.data.token
          t.getReporte()

          t.cargando = false
        })
        .catch(err => console.error(err))
    }
  }
}
</script>

<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem
</style>
